/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { FormControlOption } from '../../FormControl/FormControl.defs';
import { FormFieldProps } from '../../FormField.props';
import { CHECKBOX_RADIO_TYPE_BASIC, CheckboxRadioType } from './CheckboxRadio.types';

/**
 * The props for `<CheckboxList />` and `<RadioButton />`.
 */
export interface CheckboxRadioProps extends FormFieldProps {
  /**
   * The function to return the checked state boolean.
   */
  checkboxCallback?(value: boolean): void;

  /**
   * The function to return the updated options in a checkbox list.
   */
  checkboxListCallback?(updatedOptions: Array<FormControlOption>): void;

  /**
   * Checked state.
   */
  checked?: boolean;

  /**
   * Option to tab over labels instead of checkbox/radio buttons - useful when hiding the radio.
   */
  tabOverLabels?: boolean;

  /**
   * Options to include for checkbox lists and radio buttons.
   */
  options?: Array<FormControlOption>;

  /**
   * The function to return the chosen radio option.
   */
  radioCallback?(option: FormControlOption): void;

  /**
   * Field variant.
   */
  variant?: CheckboxRadioType;
}

/**
 * The default prop values for `<CheckboxList />` and `<RadioButton />`.
 */
export const checkboxRadioPropsDefaults = {
  options: [],
  variant: CHECKBOX_RADIO_TYPE_BASIC,
};
